import MainHeader from '../Header/MainHeader';
import AdminPanel from './AdminPanel';

import classes from './Home.module.scss';
import BeforeLogin from './BeforeLogin';
import { useSelector } from 'react-redux';

export default function Home() {
  const isLogedIn = useSelector((state) => state.authentication.isLogedIn);

  return (
    <div className={classes.app}>
      <MainHeader />
      {!isLogedIn && <BeforeLogin />}
      {isLogedIn && <AdminPanel />}
    </div>
  );
}
